import React from 'react'

const Footer = () => {
  return (
      <div className="footer">
        <p>
          @ Developed By    <a href='http://saaddev-io.web.app/' target='_blank' rel="noreferrer">SaadDev</a>
        </p>
      </div>
  )
}

export default Footer